import { ITimeRule, ITimeRuleOverride } from '@sparelabs/domain-logic'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export interface ITimeRulePostBody {
  name: string
  rules: ITimeRule[]
  ruleOverrides: ITimeRuleOverride[]
}

export interface ITimeRuleResponse extends IModelJsonValues {
  id: string
  name: string
  rules: ITimeRule[]
  ruleOverrides: ITimeRuleOverride[]
}

export interface ITimeRulePatchBody {
  name?: string
  rules?: ITimeRule[]
  ruleOverrides?: ITimeRuleOverride[]
}

export interface ITimeRuleListQueryParams extends IListModelQueryParamValues {
  search?: string
}

/**
 *   The interaction between the time rules and time windows:
 * - `onlyRequestedTime`: only requestedPickupTs or requestedDropoffTs is restricted. The scheduled times may end up outside the time rules.
 * - `trimRelevantToFit`: the relevant window must overlap with time rules. If Service config ArriveByPickupTimeFlexibilityType == Pickup Flexibility Only, both windows are relevant.
 *      Any window parts that are outside the time rules is stripped to fit. The relative constraints may end up outside the time rules.
 * - `relevantMustFit`: the relevant window must fully fit within time rules. If Service config ArriveByPickupTimeFlexibilityType == Pickup Flexibility Only, both windows are relevant.
 *      The relative constraints may end up outside the time rules.
 */
export enum TimeRulesBehaviour {
  OnlyRequestedTime = 'onlyRequestedTime',
  TrimRelevantToFit = 'trimRelevantToFit',
  RelevantMustFit = 'relevantMustFit',
}

export { ITimeRule, ITimeRuleOverride, TimeRuleDays, ITimeRuleSet } from '@sparelabs/domain-logic'
